
import {injectEnv} from "@fd/Environment";

export interface CrmFormFile {
	id: string;
	fileName: string;
	contentType: string;
	fileSize: number;
	attFile: number;
}

export function useCrmFormFile() {
	
	const env = injectEnv();
	
	function blobToFile(blob: Blob, fileName?: string): File {
		let name = fileName?fileName:clipboardName();
		const file = new File([blob], name, { type: blob.type });
		//console.log("create file from blob:"+file.name+" of type:"+file.type);
		return file
	}
	
	function attFileToFile(id: number, fileName: string): File {
		const file = new File([id.toString()], fileName, { type: "application/crm-file" });
		//console.log("create file from attFile:"+file.name+" of type:"+file.type);
		return file
	}
	
	function textToFile(text: string, fileName?: string): File {
		let name = fileName?fileName:clipboardName();
		const file = new File([text], name, { type: 'text/plain' });
		//console.log("create file from blob:"+file.name+" of type:"+file.type);
		return file
	}
	
	function urlToFile(url: string): File {
		let fileName = getNameFromUrl(url);
		const blob = "[InternetShortcut]\nURL="+url;
		const file = new File([blob], fileName, { type: "application/webloc" });
		//console.log("create file from blob:"+file.name+" of type:"+file.type);
		return file
	}
	
	function clipboardName(): string {
		var fileName = env.msg("fileZone.clipboard");
		if (fileName === null || fileName === undefined) {
			fileName = "Clipboard";
		}
		fileName = fileName+"-"+ new Date().toISOString().slice(0,-8); //cut millis
		return fileName;
	}
	
	function thumbnailUrl(file: CrmFormFile, thumbnailSize: number = 0) {
		return "./thumbnail?crmFormFile="+file.id
			+"&height="+thumbnailSize+"&width="+thumbnailSize+"&random="+Math.random();
	}
	
	function limitFileName(file: CrmFormFile): string {
		let limit: number = 29;
		if (file.fileName.length>limit) {
			return file.fileName.substring(0, limit)+"...";
		}
		return file.fileName;
	}
	
	function getNameFromUrl(url: string): string
	{
		if (url) {
			if (url.endsWith("/")) {
				url=url.substring(0,url.length-1);
			}
			let name = url.substring(url.lastIndexOf("/")+1);
			if (name.indexOf('?')>0) {
				name = name.substring(0,name.indexOf('?'));
			}
			return name+".url";
		}
		console.log("Invalid value url:"+url);
		return "link.url";
	}
	
	function asPromise(clipboardItem: ClipboardItem): Promise<File>
	{
		return new Promise((resolve, reject) => {
			//console.log("types:"+clipboardItem.types);
			const type = clipboardItem.types[0];
			//console.log("type:"+type);
			if (type==='text/plain') {
				clipboardItem.getType(type)
				.then(blob => blob.text())
				.then(text=>{
					if (text.startsWith('http')) {
						resolve(urlToFile(text));
					}
					else {
						resolve(textToFile(text));
					}
				})
				.catch((error) => {
					reject(error);
				});
			}
			else {
				clipboardItem.getType(type)
				.then(blob=>{
					resolve(blobToFile(blob));
				})
				.catch((error) => {
					reject(error);
				});
			}
		});
	}
	
	return  { attFileToFile, clipboardName, thumbnailUrl, 
			limitFileName, urlToFile, asPromise };
}

